import React, { /*useCallback,*/ useState, useEffect, Fragment, useRef } from "react";
import Container from 'react-bootstrap/Container';
import axios from 'axios';
import AuthService from '../../Auth/AuthService.js';
//import settings from './../../Settings.json';
import { settings } from './../../Helpers/Settings.js';
import { ToastContainer, toast } from "react-toastify";
import { useDownloadExcel } from 'react-export-table-to-excel';
import { useLocation } from 'react-router-dom';
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import Swal from 'sweetalert2'
import PageTitle from "../../Components/PageTitle.js";
import { decodeToken, isExpired } from "react-jwt";

const Tanim = () => {
    const location = useLocation();

    const [isTokenExpired, setIsTokenExpired] = useState(false);
    const [yetkiGor, setYetkiGor] = useState(null);
    const [yetkiEkle, setYetkiEkle] = useState(false);
    const [yetkiDegistir, setYetkiDegistir] = useState(false);
    const [yetkiSil, setYetkiSil] = useState(false);

    const [currentId, setCurrentId] = useState(0);
    const [tanimForInsert, setTanimForInsert] = useState('');
    const [kisaltmaForInsert, setKisaltmaForInsert] = useState('');
    const [kodForInsert, setKodForInsert] = useState('');
    const [tanimForUpdate, setTanimForUpdate] = useState('');
    const [kisaltmaForUpdate, setKisaltmaForUpdate] = useState('');
    const [kodForUpdate, setKodForUpdate] = useState('');
    const [prm, setPrm] = useState("");

    const [data, setData] = useState(null);
    const [dataTanimCesidi, setDataTanimCesidi] = useState(null);

    const tableRef = useRef(null);

    const tokenYenile = async () => {
        if (isExpired(localStorage.getItem('ATGroupToken')) === true) {
            setIsTokenExpired(true);
            return false;
        } else {
            const mail = decodeToken(localStorage.getItem('ATGroupToken'))["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress"];
            await AuthService.login(mail, localStorage.getItem('ATGroupToken'));
            return true;
        }
    }

    useEffect(() => {
        getAcilisData();
    }, []);

    useEffect(() => {
        if (yetkiGor === true){
            getData("");
        }        
    }, [prm, location]);

    const getAcilisData = async () => {
        if (tokenYenile() === false) {
            return;
        }

        try {
            const pathArray = window.location.pathname.split('/');

            const tfnTemp = pathArray[pathArray.length - 1];

            if (tfnTemp && tfnTemp !== "") {
                const tanimCesidiTemp = await axios.get(settings.ApiUrl + 'Tanim/GetTanimCesidi/' + tfnTemp, { headers: AuthService.getHeaders() });

                if (tanimCesidiTemp && tanimCesidiTemp.data && tanimCesidiTemp.data.value.tanim) {
                    setDataTanimCesidi(tanimCesidiTemp.data.value);

                    let tempYetkiGor = await AuthService.getYetkiKontrolByYetki("Tanımlamalar - " + tanimCesidiTemp.data.value.baslikCogul + " - Gör");

                    setYetkiGor(tempYetkiGor);

                    if (tempYetkiGor === true){
                        setYetkiEkle(await AuthService.getYetkiKontrolByYetki("Tanımlamalar - " + tanimCesidiTemp.data.value.baslikCogul + " - Ekle"));
                        setYetkiDegistir(await AuthService.getYetkiKontrolByYetki("Tanımlamalar - " + tanimCesidiTemp.data.value.baslikCogul + " - Değiştir"));
                        setYetkiSil(await AuthService.getYetkiKontrolByYetki("Tanımlamalar - " + tanimCesidiTemp.data.value.baslikCogul + " - Sil"));

                        await getData(tanimCesidiTemp.data.value.tanim);
                    }
                }
            }

        } catch (error) {
            console.log(error);
        }
    }

    const getData = async (tanimCesidi) => {
        try {
            if (tanimCesidi === "") {
                tanimCesidi = dataTanimCesidi.tanim;
            }

            const res = await axios.get(settings.ApiUrl + 'Tanim/GetTanimList/' + tanimCesidi + "/" + (prm === "" ? "~" : prm), { headers: AuthService.getHeaders() });

            if (res) {
                setData(res.data.value);
            }
        } catch (error) {
            console.log(error);
        }
    }

    const handlePrmChange = (e) => {
        if (tokenYenile() === false) {
            return;
        }

        setPrm(e.target.value);
    }

    const Degistir = async (id) => {
        if (tokenYenile() === false) {
            return;
        }

        try {
            const result = await axios.get(settings.ApiUrl + 'Tanim/GetTanim/' + dataTanimCesidi.tanim + "/" + id, { headers: AuthService.getHeaders() });

            if (result) {
                setCurrentId(id);
                setTanimForUpdate(result.data.value.tanim);
                setKisaltmaForUpdate(result.data.value.kisaltma);
                setKodForUpdate(result.data.value.kod);
            }
        } catch (error) {
            toast.error(error);
        }
    }

    const Sil = async (id) => {
        if (tokenYenile() === false) {
            return;
        }

        Swal.fire({
            title: "Uyarı",
            text: "Kayıt silinecek, emin misiniz?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Sil",
            cancelButtonText: "Vazgeç"
        }).then(async (resultSwal) => {
            if (resultSwal.isConfirmed) {
                try {
                    const resultGet = await axios.get(settings.ApiUrl + 'Tanim/GetTanim/' + dataTanimCesidi.tanim + "/" + id, { headers: AuthService.getHeaders() });

                    if (resultGet) {
                        const resultDelete = await axios.post(settings.ApiUrl + 'Tanim/DeleteTanim/', [resultGet.data.value], { headers: AuthService.getHeaders() });

                        if (resultDelete) {
                            if (resultDelete.data.success === true) {
                                await getData("");
                                toast.success("Silindi");
                            } else {
                                toast.error(resultDelete.data.message);
                            }
                        }
                    }
                } catch (error) {
                    toast.error(error);
                }
            }
        });
    }

    const Kaydet = async (kayitModu) => {
        if (tokenYenile() === false) {
            return;
        }
        
        let tanim = kayitModu === "insert" ? tanimForInsert : tanimForUpdate;
        let kisaltma = dataTanimCesidi.kisaltmali === true ? kayitModu === "insert" ? kisaltmaForInsert : kisaltmaForUpdate : "";
        let kod = dataTanimCesidi.kodlu === true ? kayitModu === "insert" ? kodForInsert : kodForUpdate : "";

        if (tanim === "") {
            Swal.fire({ title: "Hata", text: "Lütfen zorunlu alanları doldurunuz", icon: "error" });
        } else {
            try {
                const data = JSON.stringify({
                    "id": kayitModu === "insert" ? 0 : currentId,
                    "tanimCesidi": dataTanimCesidi.tanim,
                    "tanim": tanim,
                    "kisaltma": kisaltma,
                    "kod": kod
                });

                const result = await axios.post(settings.ApiUrl + 'Tanim/InsertOrUpdateTanim/', data, { headers: AuthService.getHeaders() });

                if (result) {
                    if (result.data.success) {
                        setCurrentId(0);

                        if (kayitModu === "insert") {
                            setTanimForInsert("");
                            setKisaltmaForInsert("");
                            setKodForInsert("");
                        }

                        await getData("");
                        toast.success("Kaydedildi");
                    } else {
                        toast.error("Hata oluştu: " + result.data.message);
                    }
                }
            } catch (error) {
                toast.error("Hata oluştu:" + error);
            }
        }
    }

    const Vazgec = async () => {
        setCurrentId(0);
    }

    const { onDownload } = useDownloadExcel({
        currentTableRef: tableRef.current,
        filename: dataTanimCesidi ? dataTanimCesidi.tanim + 'Listesi' : "",
        sheet: dataTanimCesidi ? dataTanimCesidi.tanim + 'Listesi' : ""
    })

    return (
        <Fragment>
            <Container>
                <ToastContainer position="bottom-right">
                </ToastContainer>
            </Container>

            {
                dataTanimCesidi ? 
                    <div className="row">
                        <div className="col-md-10">
                            <PageTitle></PageTitle>
                        </div>
                        <div className="col-md-2 text-right">
                            <div className="input-group input-group-sm mb-3">
                                <input type="text" className="form-control" aria-describedby="inputGroup-sizing-sm" placeholder="Arama..." value={prm} onChange={(e) => handlePrmChange(e)}></input>
                                <span className="input-group-text" id="inputGroup-sizing-sm"><i className="bi bi-search"></i></span>
                            </div>
                        </div>
                    </div>
                    :
                ""
            }

            {
                isTokenExpired === true ?
                    <div className="alert alert-danger mb-1">
                        <button className="btn btn-link btn-sm" style={{color:"#58151c"}} onClick={() => AuthService.logout()}>Uzun süredir işlem yapmadığınız için oturumunuz sonlandırıldı. Lütfen tekrar giriş yapınız.</button>
                    </div>
                    :
                    yetkiGor !== null ?
                        yetkiGor === false ?
                            <div className="alert alert-danger">
                                Bu sayfaya erişim yetkiniz bulunmamaktadır
                            </div>
                            :
                            dataTanimCesidi ? 
                                <div className="card info-card mb-2">
                                    <div className="table-responsive">
                                        <table ref={tableRef} className="table table-bordered table-hover table-sm mb-0">
                                            <thead>
                                                <tr>
                                                    <th style={{textAlign:"center"}}>{dataTanimCesidi.baslikTekil}</th>
                                                    {
                                                        dataTanimCesidi.kisaltmali === true ?
                                                            <th style={{textAlign:"center"}}>Kısaltma</th>
                                                            :
                                                            ""
                                                    }
                                                    {
                                                        dataTanimCesidi.kodlu === true ?
                                                            <th style={{textAlign:"center"}}>Kod</th>
                                                            :
                                                            ""
                                                    }
                                                    <th style={{textAlign:"center"}}>
                                                        <button className="btn btn-sm btn-icon text-success" onClick={onDownload}><i className="bi bi-file-earmark-excel"></i></button>
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <th style={{textAlign:"center"}}>
                                                        <input type="text" className="form-control form-control-sm" value={tanimForInsert} onChange={(e) => setTanimForInsert(e.target.value)}></input>
                                                    </th>
                                                    {
                                                        dataTanimCesidi.kisaltmali === true ?
                                                            <th style={{textAlign:"center"}}>
                                                                <input type="text" className="form-control form-control-sm" value={kisaltmaForInsert} onChange={(e) => setKisaltmaForInsert(e.target.value)}></input>
                                                            </th>
                                                            :
                                                            ""
                                                    }
                                                    {
                                                        dataTanimCesidi.kodlu === true ?
                                                            <th style={{textAlign:"center"}}>
                                                                <input type="text" className="form-control form-control-sm" value={kodForInsert} onChange={(e) => setKodForInsert(e.target.value)}></input>
                                                            </th>
                                                            :
                                                            ""
                                                    }
                                                    <th style={{textAlign:"center"}}>
                                                        { yetkiEkle === true ? <button className="btn btn-sm btn-icon text-success" onClick={() => Kaydet("insert")}><i className="bi bi-plus-circle"></i></button> : '' }
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    data && data.length > 0 ?
                                                        data.map((item, index) => {
                                                            return (
                                                                <tr key={index}>
                                                                    <td align="center">
                                                                        {
                                                                            currentId === item.id ?
                                                                                <input type="text" className="form-control form-control-sm" value={tanimForUpdate} onChange={(e) => setTanimForUpdate(e.target.value)}></input>
                                                                                :
                                                                                item.tanim
                                                                        }
                                                                    </td>
                                                                    {
                                                                        dataTanimCesidi.kisaltmali === true ?
                                                                            <td align="center">
                                                                                {
                                                                                    currentId === item.id ?
                                                                                        <input type="text" className="form-control form-control-sm" value={kisaltmaForUpdate} onChange={(e) => setKisaltmaForUpdate(e.target.value)}></input>
                                                                                        :
                                                                                        item.kisaltma
                                                                                }
                                                                            </td>
                                                                            :
                                                                            ""
                                                                    }
                                                                    {
                                                                        dataTanimCesidi.kodlu === true ?
                                                                            <td align="center">
                                                                                {
                                                                                    currentId === item.id ?
                                                                                        <input type="text" className="form-control form-control-sm" value={kodForUpdate} onChange={(e) => setKodForUpdate(e.target.value)}></input>
                                                                                        :
                                                                                        item.kod
                                                                                }
                                                                            </td>
                                                                            :
                                                                            ""
                                                                    }
                                                                    <td align="center">
                                                                        {
                                                                            currentId === item.id ?
                                                                                <div className="btn-group">
                                                                                    <button className="btn btn-sm btn-icon text-success" onClick={() => Kaydet("update")}><i className="bi bi-check-circle"></i></button>
                                                                                    <button className="btn btn-sm btn-icon text-danger" onClick={() => Vazgec()}><i className="bi bi-x-circle"></i></button>
                                                                                </div>
                                                                                :
                                                                                <div className="btn-group">
                                                                                    { yetkiDegistir === true ? <button className="btn btn-sm btn-icon text-info" onClick={() => Degistir(item.id)}><i className="bi bi-pencil"></i></button> : '' }
                                                                                    { yetkiSil === true ? <button className="btn btn-sm btn-icon text-danger" onClick={() => Sil(item.id)}><i className="bi bi-trash3"></i></button> : '' }
                                                                                </div>
                                                                        }
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })
                                                        :
                                                        <tr>
                                                            <td align="center" colSpan="2" style={{height:"48px"}}>
                                                                Kayıt yok
                                                            </td>
                                                        </tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            :
                            ""
                        :
                        ""
            }

        </Fragment>
    );
};

export default Tanim;